import IngredientsLocator, {
  IngredientsLocatorProps,
} from "./IngredientsLocator";

export { IngredientsLocator, IngredientsLocatorProps };

export default IngredientsLocator;
